var categorySalesData = [
    {
        'RPT_CATEGORY_SALES_ID': 8669757.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1732045.0,
        'CATEGORY_NAME': 'DON JULIO',
        'SALES_AMT': 11.50,
        'SALES_CNT': 1.0,
        'SALES_PCT': 0.15,
        'LOAD_TIME': '2020-04-16T19:25:00',
        'BUSINESS_DATE': '2020-04-16T00:00:00'
    },
    {
        'RPT_CATEGORY_SALES_ID': 8669758.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1732045.0,
        'CATEGORY_NAME': 'DESSERT',
        'SALES_AMT': 121.40,
        'SALES_CNT': 33.0,
        'SALES_PCT': 1.63,
        'LOAD_TIME': '2020-04-16T19:25:00',
        'BUSINESS_DATE': '2020-04-16T00:00:00'
    },
    {
        'RPT_CATEGORY_SALES_ID': 8669759.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1732045.0,
        'CATEGORY_NAME': 'BEVERAGE',
        'SALES_AMT': 97.25,
        'SALES_CNT': 38.0,
        'SALES_PCT': 1.30,
        'LOAD_TIME': '2020-04-16T19:25:00',
        'BUSINESS_DATE': '2020-04-16T00:00:00'
    },
    {
        'RPT_CATEGORY_SALES_ID': 8669760.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1732045.0,
        'CATEGORY_NAME': 'LIQUOR',
        'SALES_AMT': 2530.90,
        'SALES_CNT': 585.0,
        'SALES_PCT': 33.89,
        'LOAD_TIME': '2020-04-16T19:25:00',
        'BUSINESS_DATE': '2020-04-16T00:00:00'
    },
    {
        'RPT_CATEGORY_SALES_ID': 8669761.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1732045.0,
        'CATEGORY_NAME': 'ENTREES',
        'SALES_AMT': 3193.47,
        'SALES_CNT': 189.0,
        'SALES_PCT': 42.77,
        'LOAD_TIME': '2020-04-16T19:25:00',
        'BUSINESS_DATE': '2020-04-16T00:00:00'
    },
    {
        'RPT_CATEGORY_SALES_ID': 8669762.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1732045.0,
        'CATEGORY_NAME': 'BEER',
        'SALES_AMT': 825.55,
        'SALES_CNT': 204.0,
        'SALES_PCT': 11.06,
        'LOAD_TIME': '2020-04-16T19:25:00',
        'BUSINESS_DATE': '2020-04-16T00:00:00'
    },
    {
        'RPT_CATEGORY_SALES_ID': 8669763.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1732045.0,
        'CATEGORY_NAME': 'BOGLE',
        'SALES_AMT': 19.50,
        'SALES_CNT': 3.0,
        'SALES_PCT': 0.26,
        'LOAD_TIME': '2020-04-16T19:25:00',
        'BUSINESS_DATE': '2020-04-16T00:00:00'
    },
    {
        'RPT_CATEGORY_SALES_ID': 8669764.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1732045.0,
        'CATEGORY_NAME': 'WINE',
        'SALES_AMT': 667.49,
        'SALES_CNT': 104.0,
        'SALES_PCT': 8.94,
        'LOAD_TIME': '2020-04-16T19:25:00',
        'BUSINESS_DATE': '2020-04-16T00:00:00'
    }
]

export default categorySalesData;